import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-566797d2")

_pushScopeId("data-v-566797d2")
const _hoisted_1 = {
  key: 0,
  class: "panel external-comments-panel"
}
const _hoisted_2 = { class: "panel-heading is-flex" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "label external-comment-label" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-comments mr-2" }),
  /*#__PURE__*/_createTextVNode("Registration Status Comments")
], -1)
const _hoisted_4 = {
  class: "buttons",
  style: {"margin-left":"auto"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus-circle" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "Add", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fas fa-sd-card" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "Save", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-undo" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "Cancel", -1)
const _hoisted_11 = {
  key: 1,
  class: "notification"
}
const _hoisted_12 = { style: {"white-space":"pre-wrap"} }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_toggleButton = _resolveComponent("toggleButton")

  return (_ctx.isExternalCommentVisible)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            (!_ctx.isEditing)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  class: "button is-small is-rounded is-outlined",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modifyNote()))
                }, [
                  _hoisted_5,
                  _hoisted_6
                ]))
              : _createCommentVNode("", true),
            (_ctx.isEditing)
              ? (_openBlock(), _createBlock("button", {
                  key: 1,
                  disabled: _ctx.isLoading,
                  type: "button",
                  class: "button is-dark is-small is-rounded",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createNote()))
                }, [
                  _hoisted_7,
                  _hoisted_8
                ], 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.isEditing)
              ? (_openBlock(), _createBlock("button", {
                  key: 2,
                  type: "button",
                  disabled: _ctx.isLoading,
                  class: "button is-small is-rounded is-outlined",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelEditing()))
                }, [
                  _hoisted_9,
                  _hoisted_10
                ], 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.isEditing)
          ? _withDirectives((_openBlock(), _createBlock("textarea", {
              key: 0,
              class: "external-comments-text-area panel-block",
              ref: "externalComments",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.externalNote.note = $event)),
              name: "comments"
            }, null, 512)), [
              [_vModelText, _ctx.externalNote.note]
            ])
          : _createCommentVNode("", true),
        (_ctx.anyExistingNotes)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("p", _hoisted_12, _toDisplayString(_ctx.existingNotes[0].fullNote), 1),
              (_ctx.existingNotes.length > 1)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    (_ctx.isNotesHistoryExpanded)
                      ? (_openBlock(), _createBlock("div", _hoisted_14, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.notesExceptFirst, (note) => {
                            return (_openBlock(), _createBlock("p", {
                              key: note.id,
                              style: {"white-space":"pre-wrap"}
                            }, _toDisplayString(note.fullNote), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_toggleButton, {
                      modelValue: _ctx.isNotesHistoryExpanded,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isNotesHistoryExpanded = $event)),
                      classAlways: "mt-4 no-border",
                      iconOff: "fas fa-plus",
                      iconOn: "fas fa-minus",
                      titleOn: "Hide comments",
                      titleOff: "Show all comments"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})